import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import { ItemGrid } from '../../models/item';
import { modalComponent } from '../../utils/modal/modal.component';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import { ActivatedRoute } from '@angular/router';
import { CompanyAddress } from '../../models/direccionconpania';

@Component({
    selector: 'companyAddress-consultar',
    styleUrls: [], 
    templateUrl: 'direccionEmpresa-consultar.component.html',
    providers: [generalService]
})

export class CompanyAddressConsultarComponent implements OnInit{

    
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    dataSource: DataSourceGrid | null;
    displayedColumns = ['acciones', 
    'NAME',
    //'CITY_ID',
    'City_NAME',
    'Localidad_Name',
    'CP_Name',
    'Suburb_Name',
    ,'STREET',
    //'OUTDOOR_NUMBER','INTERIOR_NUMBER',
    'REFERENCE'];
    public datosDireccionCompania: Array<CompanyAddress>;
    public DireccionCompania :CompanyAddress;
    public dataDireccionCompania:any;

    // Modal messages
    private readonly CONFIRM_DELETE_MSG = '¿Está seguro dar de baja al Dirección?';

    constructor(private _generalService: generalService, 
        public dataService: DataService, 
        public dialog: MatDialog,
        public _activated : ActivatedRoute) {
          //this.chofer = new Chofer();
          //this.dataChofer = new Array();
    }

    ngOnInit() {
        this.consultarCompania();
    }


    consultarCompania(){
        let metodo = 'DireccionCompania/consultarDireccionCompañia';
        const params = { 
          loacs: sessionStorage.getItem('acslo')  
        };

        this._generalService.metodoCallParams(params, metodo).subscribe(
          result => {
            this.datosDireccionCompania = JSON.parse(result);
            this.dataSource = new DataSourceGrid(this.datosDireccionCompania, this.paginator, this.sort);
            },
          error => {  console.log(<any>error);  }
        );
    }
    searchFilter(searchTerm: string) {
        if(this.datosDireccionCompania.length <= 0) {
          this.dataSource = undefined;
        } else {
          let filtroVehiculos = this.datosDireccionCompania;
          if(searchTerm != "") {
            filtroVehiculos = this.datosDireccionCompania.filter((obj: any) => {            
              if (obj.NAME.toLowerCase().indexOf(searchTerm.toLowerCase()) != -1)
                  return true;
              else
                  return false;
            });
          }
          this.dataSource = new DataSourceGrid(filtroVehiculos, this.paginator, this.sort);
        }
    }

    confirmDeleteCompany(cA: CompanyAddress){
        this.dataService.modal = 'confirm';
        this.dataService.mensaje = this.CONFIRM_DELETE_MSG;
      
        const dialogModal = this.dialog.open(modalComponent, {disableClose: true});
        this.dataService.dialogRef = dialogModal;

        this.dataDireccionCompania = cA;
      
        dialogModal.afterClosed().subscribe(result => {
          if (this.dataService.guardado) {
            this.deleterow(this.dataDireccionCompania);
          }
        });
    }

    deleterow(companyAddress: any) {
        const params = { 
          loacs: sessionStorage.getItem('acslo'),
          COMPANY_ADDRESS_ID:companyAddress.COMPANY_ADDRESS_ID
        };
        this._generalService.metodoCallParams(params, `DireccionCompania/deleteDireccionCompañia`)
        .subscribe(ok => {
            
            this.consultarCompania();
            
            setTimeout(() => {
                this._generalService.toastCall("El registro se dio de baja exitosamente");
              }, 500); 

        }, error => {
          // Custom error handler
        }); 
    }
    
}



// WEBPACK FOOTER //
// ./src/app/direccionEmpresa/consultar-eliminar/direccionEmpresa-consultar.component.ts